module.exports = __webpack_public_path__ + "static/icthub-light-df367cf772d83e8ef804c7fc42b2502c.png";